export class User {
    loggedIn = false;
    user_mobile = '';
    user_email = '';
    user_name = '';
    user_type = '';
    user_userid = '';
    user_company = '';
}
